import './styles.css';
import { render } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import { Home } from './pages/Home.js';
import { TokenPage } from './pages/Token.js';
import { Create } from './pages/Create.js';
import { WalletPage } from './pages/Wallet.js';
import { Verify } from './pages/Verify.js';
import { SpeedPage } from './pages/Speed.js';
import { Tape } from './components/Tape.js';
import { Toaster } from './components/bits.js';
import { useStore, boot, totalZat } from './store.js';
import { zec } from './format.js';
import { wallet } from './wallet.js';

export const BRAND = 'dazzle';

function useRoute() {
  const [hash, setHash] = useState(location.hash || '#/');
  useEffect(() => {
    const f = () => {
      setHash(location.hash || '#/');
      window.scrollTo(0, 0);
    };
    addEventListener('hashchange', f);
    return () => removeEventListener('hashchange', f);
  }, []);
  const [path, query = ''] = hash.slice(1).split('?');
  return { parts: path.split('/').filter(Boolean), query: new URLSearchParams(query) };
}

function TopBar({ section }: { section: string }) {
  const s = useStore();
  const [q, setQ] = useState('');
  const w = wallet();
  return (
    <header class="topbar">
      <a class="wordmark" href="#/" aria-label={`${BRAND} home`}>
        <span class="coin" aria-hidden="true">
          Z
        </span>
        <span class="full">{BRAND}</span>
      </a>
      <form
        class="search"
        role="search"
        onSubmit={(e) => {
          e.preventDefault();
          location.hash = `#/?q=${encodeURIComponent(q)}`;
        }}
      >
        <input type="search" placeholder="Search coins by ticker or name" aria-label="Search coins" value={q} onInput={(e) => setQ((e.target as HTMLInputElement).value)} />
      </form>
      <nav class="nav" aria-label="Main">
        <a href="#/verify" class="hide-sm" aria-current={section === 'verify' ? 'page' : undefined}>
          Verify
        </a>
        <a class="btn brass" href="#/create">
          Launch a coin
        </a>
        <a class="wallet-chip" href="#/wallet" aria-current={section === 'wallet' ? 'page' : undefined}>
          {w && s.account?.exists ? (
            <>
              <b>{zec(totalZat())}</b>
              <span>ZEC</span>
            </>
          ) : (
            <span style={{ color: 'var(--ink)', fontWeight: 600 }}>Wallet</span>
          )}
        </a>
      </nav>
    </header>
  );
}

function App() {
  const { parts, query } = useRoute();
  const s = useStore();
  const section = parts[0] ?? '';
  let page;
  if (section === 'token' && parts[1]) page = <TokenPage id={parts[1]} key={parts[1]} />;
  else if (section === 'create') page = <Create />;
  else if (section === 'wallet') page = <WalletPage />;
  else if (section === 'verify') page = <Verify />;
  else if (section === 'speed') page = <SpeedPage />;
  else page = <Home q={query.get('q') ?? ''} />;
  const network = s.info?.genesis.network;
  return (
    <>
      <TopBar section={section} />
      <Tape />
      {network && network !== 'mainnet' && (
        <div class="notice warn" style={{ borderRadius: 0, borderWidth: '0 0 1px', textAlign: 'center' }}>
          {network === 'mock' ? 'Demo mode: no real ZEC. Deposits are simulated.' : `Running on Zcash ${network}. Coins here have no value.`}
        </div>
      )}
      <main>
        {page}
        <footer class="footer">
          <span>Beta. Deposits and withdrawals have limits while we test.</span>
          <a href="#/verify">How to check every trade yourself</a>
          <a href="#/speed">Speed</a>
          {s.info && <span>Log entry #{s.info.seq}</span>}
        </footer>
      </main>
      <Toaster />
    </>
  );
}

void boot();
render(<App />, document.getElementById('app')!);
